<script>
	export let params

	import { getContext } from 'svelte'

	import MainContainer from "./MainContainer.svelte"

    import firebase from "firebase/app"
    import "firebase/firestore"
    import "firebase/functions"
//    import "firebase/storage"

    const firebaseConsoleUrl = getContext("firebaseConsoleUrl")
    const firebaseStorageBucket = getContext("firebaseStorageBucket")
    const googleplayConsoleUrl = getContext("googleplayConsoleUrl")
	const userDetailsPlugin = getContext("userDetailsPlugin") 

    let userId = params.id
    let tickets = []
    let ticketsSize = 0

    firebase.firestore().collection("HelpDeskTickets")
                        .where("userId", "==", params.id)
                        .orderBy('creationTime', 'desc')
                        .onSnapshot(querySnapshot => {
        ticketsSize = querySnapshot.size
        tickets = querySnapshot.docs.map((ticket) => {
            //console.debug("ticket", ticket.id, ticket.data())
            return {...ticket.data(), id: ticket.id}
        })
    }, err => {
        console.log(`Encountered error: ${err}`)
		//alert(err)
    }); 


    let purchases = []
    let purchasesSize = 0

    firebase.firestore().collection("Purchases")
                        .where("userId", "==", params.id)
                        .orderBy('purchaseTimeMillis', 'desc')
                        .onSnapshot(querySnapshot => {
        purchasesSize = querySnapshot.size
        purchases = querySnapshot.docs.map(purchase => {
            //console.debug("purchase", purchase.id, purchase.data())
            return {...purchase.data(), token: purchase.id}
        })
    }, err => {
        console.log(`Encountered error: ${err}`)
		//alert(err)
    }); 


    let subscriptions = []
    let subscriptionsSize = 0

    firebase.firestore().collection("Subscriptions")
                        .doc(params.id) // UserID
                        .onSnapshot(snapshot => {
		//console.log(`Received doc snapshot: ${JSON.stringify(snapshot.data())}`)
        subscriptions = Object.values(snapshot.data())
        subscriptionsSize = subscriptions.length
	}, err => {
		console.log(`Encountered error: ${err}`)
	})


    let userCreationTime = '-'
    firebase.functions().httpsCallable('userCreationTime')({uid: params.id}).then((result) => {
        userCreationTime = result.data
    });


    async function createTicketFromSupport() {
        const supportMessageHeader = document.getElementById("support-message-header").value
        const supportMessageBody = document.getElementById("support-message-body").value
        const result = await firebase.firestore().collection("HelpDeskTickets").add({
            header: supportMessageHeader, 
            body: supportMessageBody,
            creationTime: firebase.firestore.FieldValue.serverTimestamp(), 
            modificationTime: firebase.firestore.FieldValue.serverTimestamp(),
            needReplyFromAdmin: true,
            userId: params.id
        })
        window.location.href = "/#/Ticket/" + result.id
    }

	import {afterUpdate} from 'svelte';
	afterUpdate(async () => {
		const elems = document.querySelectorAll('.modal')
        const instances = M.Modal.init(elems, {
            onOpenEnd: () => document.getElementById("support-message-header").focus()
        })
	})

	// let files;
	// $: if (files) {
	// 	console.log(files);

	// 	for (const file of files) {
	// 		console.log(`${file.name}: ${file.size} bytes`);
	// 	}
    // }
    
    // let progressUrl = '' 
    // firebase.storage().ref(`GameState/${params.id}/Test.jpg`).getDownloadURL().then((url) => {
    //     progressUrl = url
    // })

</script>

<MainContainer>
	<h4>User</h4>
    <div class="card horizontal"> 
        <div class="card-stacked">
            <div class="card-content">
                {#if purchasesSize > 0}
                    <div class="chip red right"><i class="material-icons">attach_money</i></div>
                {/if}
                <span class="card-title">ID: {params.id}</span>
                <p>Creation time: {userCreationTime}</p>
                <svelte:component this={userDetailsPlugin} userId={userId} firebase={firebase}/>
            </div>
            <div class="card-action">
                <a href={firebaseConsoleUrl + "/storage/" + firebaseStorageBucket + "/files/~2FGameState~2F" + params.id}>Manage progress</a>

                <!-- Modal Trigger -->
                <a class="modal-trigger" href="#modal-create-ticket">Create ticket</a>

                <!-- Modal Structure -->
                <div id="modal-create-ticket" class="modal">
                    <div class="modal-content">
                        <h5>Create ticket from support</h5>
                        <form>
                            <div class="input-field">
                                <input id="support-message-header" class="validate" type="text" value="Message from support" />
                                <label for="support-message-header">Header:</label>
                            </div>
                            <div class="input-field">
                                <textarea id="support-message-body" class="materialize-textarea"  />
                                <label for="support-message-body">Body:</label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a class="modal-close waves-effect waves btn" on:click={createTicketFromSupport}>Submit</a>
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a class="modal-close waves-effect waves btn-flat">Cancel</a>
                    </div>
                </div>                
            </div>
        </div>
    </div> 

    <!-- <div class="upload-progress-container">
        <div class="file-field input-field">
            <div class="btn">
                <span>Upload</span>
                <input type="file" bind:files>
            </div>
            <div class="file-path-wrapper">
                <input class="file-path validate" type="text" placeholder="Progress file">
            </div>
          </div>        
    </div> -->

    <div class="items-container">
        <h5>Tickets ({ticketsSize})</h5>
        <div class="collection">
            {#each tickets as ticket}
            <a href="/#/Ticket/{ticket.id}" class="collection-item">
                {#if ticket.needReplyFromAdmin}
                    <span class="new badge red"></span>
                {/if}
                {ticket.creationTime ? ticket.creationTime.toDate().toLocaleString() : "-"} - {ticket.header}
            </a>
            {/each}
          </div>        
    </div>

    <div class="items-container">
        <h5>Purchases ({purchasesSize})</h5>
        <div class="collection">
            {#each purchases as purchase}
                {#if purchase.platform == "Android"}
                    <!-- <a href={firebaseConsoleUrl +"/firestore/data~2FPurchases~2F" + purchase.token} class="collection-item"> -->
                    <a href={googleplayConsoleUrl +"/orders/" + purchase.orderId} class="collection-item">
                        <i class="material-icons right">phone_android</i>
                        {#if purchase.productPrice}
                            <span class="badge right">{purchase.productPrice}</span>
                        {/if}
                        {new Date(parseInt(purchase.purchaseTimeMillis)).toLocaleString()} - {purchase.productId} - {purchase.orderId}
                    </a>
                {:else if purchase.platform == "iOS"}
                    <div class="collection-item">
                        <i class="material-icons right">phone_iphone</i>
                        {#if purchase.productPrice}
                            <span class="badge right">{purchase.productPrice}</span>
                        {/if}
                        {new Date(parseInt(purchase.purchaseTimeMillis)).toLocaleString()} - {purchase.productId}
                    </div>
                {/if}
            {/each}
        </div>        
    </div>

    <div class="items-container">
        <h5>Subscriptions ({subscriptionsSize})</h5>
        <div class="collection">
            {#each subscriptions as subscription}
                {#if subscription.platform == "Android"}
                    <!-- <a href={firebaseConsoleUrl +"/firestore/data~2FPurchases~2F" + purchase.token} class="collection-item"> -->
                    <a href={googleplayConsoleUrl +"/orders/" + subscription.orderId} class="collection-item">
                        <i class="material-icons right">phone_android</i>
                        {#if subscription.productPrice}
                            <span class="badge right">{subscription.productPrice}</span>
                        {/if}
                        {new Date(parseInt(subscription.startTimeMillis)).toLocaleString()} - 
                            {new Date(parseInt(subscription.expiryTimeMillis)).toLocaleString()} ~
                            {subscription.productId} - {subscription.orderId}
                    </a>
                {:else if subscription.platform == "iOS"}
                    <div class="collection-item">
                        <i class="material-icons right">phone_iphone</i>
                        {#if subscription.productPrice}
                            <span class="badge right">{subscription.productPrice}</span>
                        {/if}
                        {new Date(parseInt(subscription.startTimeMillis)).toLocaleString()} - 
                            {new Date(parseInt(subscription.expiryTimeMillis)).toLocaleString()} ~
                            {subscription.productId}
                    </div>
                {/if}
            {/each}
        </div>        
    </div>
</MainContainer>


<style>
    /* .upload-progress-container {
        margin-top: 30px;
    } */
    .items-container {
        margin-top: 50px;
    }
    .chip i {
        position: relative;
        top: 4px;
    }
    .modal-content .input-field {
        margin-top: 40px;
    }
</style>